import script from "./ValidateForm.vue?vue&type=script&lang=ts"
export * from "./ValidateForm.vue?vue&type=script&lang=ts"

export default script